import dotStream from '../elements/dotStream.js';
dotStream.register();
